import { render, staticRenderFns } from "./index.vue?vue&type=template&id=88c767ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=88c767ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c767ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88c767ca')) {
      api.createRecord('88c767ca', component.options)
    } else {
      api.reload('88c767ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=88c767ca&scoped=true", function () {
      api.rerender('88c767ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/temporaryWorkerAccount/index.vue"
export default component.exports